
import classNames from "classnames";
import { ReactComponent as CloseIcon } from 'static/icons/close-small.svg';
import "../SidebarModule/SidebarModule.scss";
import ColorSidebarMainContent from "./ColorSidebarMainContent/ColorSidebarMainContent";
import { useDispatch, useSelector } from "react-redux";
import { closeSidebarAC } from "store/actions/colorSidebar";
import { useEffect } from "react";
import { resizeViewer } from "utils/builder/IScheduleLogic";

const ColorSidebar = ({
    isRight = false,
    currentTableId,
}) => {

  const dispatch = useDispatch()

  const isSidebarOpen = useSelector((state) => state.colorSidebar.isSidebarOpen)

  useEffect(() => {
    setTimeout(() => {
            resizeViewer();
          }, 310);
  }, [isSidebarOpen])

  const closeColorSidebarHandler = () => {
    dispatch(closeSidebarAC())
  }


  return (
    <div
        className={classNames({
          'sidebar-module': true,
          'sidebar-module--right': isRight,
          'sidebar-module--closed': !isSidebarOpen,
        })}
      >
        <div className="sidebar-module__header sidebar-module__header--space-between">
          <div className="sidebar-module__header_title">Conditional coloring</div>
          <div
            className="sidebar-module__close-block"
            onClick={closeColorSidebarHandler}
          >
            <CloseIcon className="sidebar-module__header_close-icon" />
          </div>
        </div>

        <div className="sidebar-module__content">
           <ColorSidebarMainContent currentTableId={currentTableId} />
        </div>
      </div>
  );
};

export default ColorSidebar;